import React,{Component} from 'react';
import Sectitle from '../Title/Sectitle'

class AppWork extends Component{
    render(){
        let ServiceData = this.props.ServiceData;
        return(
            <section className="app_service_area" id="work">
                <div className="container">
                    <Sectitle sClass="sec_title text-center mb_70 f_size_40 f_700" Title="How It Works" tClass="t_color3" TitleP="The process is quite simple. Connect with Hosts near you to reserve and arrange to move your stuff into storage."/>
                    <div className="row app_service_info">
                        {
                            ServiceData.work.map(items => {
                                return(
                                    <div className="col-lg-4" key={items.id} background="red">
                                        <div className="app_service_item wow fadeInUp" data-wow-delay="0.5s">
                                            <i className={`app_icon ${items.icon}`}></i>
                                            <h5 className="f_p f_size_22 f_600 t_color3 mt_40 mb-40">{items.title}</h5>
                                            <p className="f_400 f_size_18 mb-40">{items.p}</p>
                                            {/* <a href=".#" className="learn_btn_two">Learn More <i className="ti-arrow-right"></i></a> */}
                                        </div>
                                    </div> 
                                )
                            })
                        }
                    </div>
                </div>
            </section>
        )
    }
}
export default AppWork;